import { Typography, Stack } from '@mui/material'
import { useTexts } from '../hooks/useTexts'

export function Body() {
  const texts = useTexts()

  return (
    <Stack>
      <Typography>{texts.body.description}</Typography>
    </Stack>
  )
}
